// Track last coupon to avoid regenerating unnecessarily
let lastCouponValue = null;
let qrPollInterval = null;

// Function to generate and display the QR code for the coupon
function generateBarCode() {
  // Get the value from the coupon code input field
  let coup = $('.rivo-coupon-code').val();
  coup = coup ? coup.trim() : '';

  // If coupon code is not available, log and exit
  if (!coup) {
    console.log('Coupon not available yet.');
    return;
  }

  // Skip if value hasn't changed
  if (lastCouponValue === coup) {
    return;
  }

  // Remove any existing QR code image to prevent duplicates
  $('#barcode').remove();

  // Create the QR code image HTML using the coupon code
  const qr_image = `
    <img style="margin:0 auto; border-radius:0!important;" id="barcode"
         src="https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(coup)}&size=100x100"
         alt="QR Code" width="100" height="100" />
  `;

  // Append the QR code image to the modal body content
  $('.rivo-modal-body-content').append(qr_image);
  console.log('QR code generated:', coup);
  lastCouponValue = coup;
}

// Create a MutationObserver to watch for the modal being injected into the DOM
const bodyObserver = new MutationObserver(() => {
  // Look for the modal element by its ID
  const modal = document.getElementById('points-purchase-modal');
  if (modal) {
    console.log('Found points-purchase-modal, attaching observer…');
    // Attach an observer to the modal to watch for open/close state
    attachModalObserver(modal);
    // Attach listeners that react to coupon creation/changes inside the modal
    attachCouponListeners(modal);
    // Stop observing the body since modal is found
    bodyObserver.disconnect();
  }
});

// Start observing the document body for added/removed child elements (including subtree)
bodyObserver.observe(document.body, { childList: true, subtree: true });

// Function to attach a MutationObserver to the modal for class changes (open/close)
function attachModalObserver(modal) {
  // Create a MutationObserver to watch for class attribute changes on the modal
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      // Check if the class attribute changed
      if (m.attributeName === 'class') {
        // Determine if the modal is open (has 'is-open' or 'is-active' class)
        const isOpen = modal.classList.contains('is-open') || modal.classList.contains('is-active');
        if (isOpen) {
          console.log('Modal opened. Generating QR…');
          // Start/refresh polling until coupon is present
          startCouponPolling();
          // Immediate attempt (in case already present)
          generateBarCode();
        }
      }
    });
  });

  // Start observing the modal for changes to the 'class' attribute
  observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
  console.log('Observer attached to modal.');
}

// Attach listeners to respond when the coupon is created after user clicks Redeem
function attachCouponListeners(modal) {
  const $modal = $(modal);

  // When the redeem button is clicked, begin polling for newly created code
  $modal.on('click', '.rivo-redeem-button, .rivo-redeem, [data-rivo-action="redeem"], button:contains("Redeem")', () => {
    console.log('Redeem clicked, waiting for coupon code…');
    startCouponPolling();
  });

  // Listen to value changes on the coupon input if events are fired
  $modal.on('input change', '.rivo-coupon-code', () => {
    generateBarCode();
  });

  // Observe DOM mutations inside the modal to catch when the coupon input is added or updated
  const subtreeObserver = new MutationObserver(() => {
    // If coupon appears or changes without firing events, attempt generation
    const val = $('.rivo-coupon-code').val();
    if (val && val.trim()) {
      generateBarCode();
    }
  });
  subtreeObserver.observe(modal, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'class'] });
}

// Start a single polling interval to detect coupon creation/update
function startCouponPolling() {
  // Clear any existing polling interval
  if (qrPollInterval) {
    clearInterval(qrPollInterval);
    qrPollInterval = null;
  }
  // Poll every 100ms up to a reasonable duration; we also let it persist while modal is open
  qrPollInterval = setInterval(() => {
    const val = $('.rivo-coupon-code').val();
    if (val && val.trim()) {
      generateBarCode();
      // Keep interval alive to catch subsequent regenerations only if you expect multiple codes per open.
      // Otherwise, uncomment to stop after first success:
      // clearInterval(qrPollInterval);
      // qrPollInterval = null;
    }
  }, 100);
}
